export default "__VITE_ASSET__C51DsfVb__"